import {makeAutoObservable} from "mobx";
import messageList from "components/live/messageList.jsx";
import {id} from "camelcase";


class GroupStore {
    memberList = [];
    info = undefined;

    constructor() {
        makeAutoObservable(this)
    }
}

class LiveRoomStore {
    playing = false;
    startingPlay = false;
    fullScreen = false;
    timReady = false;
    group = new GroupStore();
    live = undefined;
    liveTask = undefined;
    player = undefined;
    conversationProfile = undefined;
    messageList = [];
    bulletComment = '';
    currentGoods = undefined;


    constructor() {
        makeAutoObservable(this)
    }

    init() {
        this.playing = false
        this.startingPlay = false
        this.fullScreen = false
        this.timReady = false
        this.group = new GroupStore()
        this.live = undefined
        this.liveTask = undefined
        this.player = undefined
        this.conversationProfile = undefined
        this.messageList = []
        this.bulletComment = ''
        this.currentGoods = undefined
    }

    putMessage(message) {
        this.messageList = [...this.messageList, message]
    }
    
    putMessageList(messageList) {
        this.messageList = [...this.messageList, ...messageList]
    }

    removeMessage(id) {
        this.messageList = [...this.messageList].filter(item => item.ID !== id)
    }
}

export default new LiveRoomStore();